/**
 * Created by luka on 23.02.2018.
 */
import {post} from "../utils/api";
import {
    resetNavigationToOverview
} from "../navigation/NavigationActions";
import {
    LOADING_REORDER_FAILED, REORDER_CORRUPTED,
    REORDER_LOADING, SUBMIT_ALREADY_MISSED,
} from "../actions/types";
import {REORDER_SUCCESSFUL} from "../utils/constants";
import {getHideShare, hasSurveyCount} from "../utils/settingsStore";
import {clearWorkout} from "../utils/workoutStore";

export function loadingReorderFailed(error) {
    return {
        type: LOADING_REORDER_FAILED,
        error
    };
}

export function reorderCorrupted() {
    return {
        type: REORDER_CORRUPTED,
    };
}

export function reorderLoading(bool) {
    return {
        type: REORDER_LOADING,
        isLoading: bool
    };
}

export function reorderFetchData(days) {
    return (dispatch) => {
        dispatch(reorderLoading(true));

        post('reorder', {
            days: days
        })
            .then((submitResponse) => {
                if (submitResponse.msg === REORDER_SUCCESSFUL) {
                    clearWorkout();
                    dispatch(resetNavigationToOverview());
                }else{
                    dispatch(reorderCorrupted())
                }
                dispatch(reorderLoading(false));
            })
            .catch((error) => {
                dispatch(loadingReorderFailed(error));
                dispatch(reorderLoading(false));
            });
    };
}



// WEBPACK FOOTER //
// ./src/reorder/ReorderAction.js